import { Grid, Typography } from '@mui/material';
import { type ChartValuesCount, type ChartValuesAmount } from 'src/shared/types/chartsData';
import ChartLegend, { type ChartLegendProps } from '../ChartLegend';
import { GridWrapper } from './styles';

type TransferChartProps = {
  title: string;
  data: ChartValuesAmount | ChartValuesCount;
  labels: string[];
  Chart: React.ElementType;
  legendProps: ChartLegendProps[];
  stacked?: boolean;
};

const TransferChart = ({ title, data, labels, Chart, legendProps, stacked }: TransferChartProps) => {
  return (
    <Grid container item xs={12}>
      <GridWrapper container item height={'100%'} width={'100%'}>
        <Grid container item>
          {legendProps.map(legend => {
            return <ChartLegend {...legend} />;
          })}
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h2">{title}</Typography>
        </Grid>
        <Grid item xs={12} height={'375px'}>
          <Chart data={data} labels={labels} stacked={stacked} />
        </Grid>
      </GridWrapper>
    </Grid>
  );
};

export default TransferChart;
